import React, { useEffect, useState } from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { enqueueSnackbar } from "notistack";
import { useHistory, useParams } from "react-router-dom";
import Header from "../../../../components/Header";
import Loading from "../../../../components/Loading";
import Container from "../../../../componentsv2/Container";
import Paper from "../../../../componentsv2/Paper";
import Button from "../../../../componentsv2/Button";
import GridContainer from "../../../../componentsv2/GridContainer";
import GridItem from "../../../../componentsv2/GridItem";
import { Input } from "../../../../componentsv2/Input";
import { api } from "../../../../services/Api";
import getApiErrorMessage from "../../../../utils/getApiErrorMessage";

export default function VisualizarEnfermeiroAgendaCare() {
  const history = useHistory();
  const { enfermeiroId } = useParams();
  const [nome, setNome] = useState("");
  const [username, setUsername] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const carregar = async () => {
      if (!enfermeiroId) {
        return;
      }
      setLoading(true);
      try {
        const {
          data: { data },
        } = await api.get(`/v2/agendaCare/enfermeiro/${enfermeiroId}`);

        if (!data?.id) {
          enqueueSnackbar("Enfermeiro não encontrado.", { variant: "warning" });
          setNome("");
          setUsername("");
          return;
        }

        const usuario = data.usuario;
        setNome(usuario?.funcionario?.nome_usu || usuario?.funcionarios?.nome_usu || "");
        setUsername(usuario?.username || "");
      } catch (error) {
        enqueueSnackbar(getApiErrorMessage(error, "Não foi possível carregar o enfermeiro."), { variant: "warning" });
        setNome("");
        setUsername("");
      } finally {
        setLoading(false);
      }
    };

    carregar();
  }, [enfermeiroId]);

  return (
    <>
      <Header titulo="Enfermeiro" />
      <Container>
        <Paper style={{ padding: "1rem", marginTop: "10px" }} elevation={2}>
          <GridContainer spacing={2}>
            <GridItem xs={12}>
              <Button onClick={() => history.push("/agendaCare/enfermeiros")}>
                <ArrowBackIcon style={{ color: "#003399" }} />
              </Button>
            </GridItem>
            {loading ? (
              <GridItem xs={12}>
                <Loading />
              </GridItem>
            ) : (
              <>
                <GridItem xs={12} md={6}>
                  <Input
                    inputProps={{ readOnly: true }}
                    required
                    fullWidth
                    label="Nome"
                    type="text"
                    variant="standard"
                    value={nome}
                  />
                </GridItem>
                <GridItem xs={12} md={6}>
                  <Input
                    inputProps={{ readOnly: true }}
                    required
                    fullWidth
                    label="Login"
                    type="text"
                    variant="standard"
                    value={username}
                  />
                </GridItem>
              </>
            )}
          </GridContainer>
        </Paper>
      </Container>
    </>
  );
}
